import { FC, InputHTMLAttributes } from 'react'
import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

const Button: FC<InputHTMLAttributes<HTMLInputElement>> = ({ children, ...rest }) => {
  return (
    <div>
      <Input type='radio' {...rest} />
      {children}
    </div>
  )
}

const Input = styled.input`
  accent-color: ${o => o.theme.color.deprecated.obsidian};
  vertical-align: text-top;
  margin: 0 ${props => props.theme.spacing(2)} 0 0;
`

const Label = styled.label`
  ${TypeStyle.css.headlineMicro}
  padding: ${props => props.theme.spacing(4)} 0 0 0;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`

export const EmbroideryRadio = { Button, Label }
